import React from "react";

const Sectorisation = ({ request }) => {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <h2 style={{ fontSize: 20, fontWeight: "bold", margin: 20 }}>Demande d'ajout à la sectorisation</h2>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <div style={{ margin: 20 }}>
            <div>Demande faite par : {request.infos.user_email}</div>
          </div>
          <div style={{ margin: 20 }}>
            <span>Nom du pdc : </span>
            <span>{request.infos.pdc_label}</span>
          </div>
          <div style={{ margin: 20 }}>
            <span>Secteur: </span>
            <span>{request.infos.sector_label}</span>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-around", marginRight: 50 }}>
          <div className="p-btn p-btn-red" onClick={() => alert("@@@todo")}>
            Refuser
          </div>
          <div className="p-btn p-btn-green" onClick={() => alert("@@@todo")}>
            Valider
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sectorisation;



// WEBPACK FOOTER //
// src/pages/basepdc/detailPdc/Request.js/Sectorisation.request.js